<template>
  <div class="ppc">
    <section class="hero is-small has-background-grey-lighter">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h2 class="title is-size-4">
            Google Ads budget calculator
          </h2>
          <h2 class="subtitle is-size-5">
            Lead generation
          </h2>
        </div>
      </div>
    </section>

    <body>
      <section class="section has-background-light">
        <div class="container">
          <h2 class="title is-size-4">Campaigns</h2>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Ad spend per month</label>
              </div>
              <div class="column">
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <input class="input" v-model="adSpend" type="number" placeholder="e.g. £10,000 per month">
                  </div>
                  <p class="annual-spend">Annual spend of {{ annualSpend }}</p>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Average Cost Per Click</label>
              </div>
              <div class="column">
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <input class="input" v-model="costPerClick" type="number" step="0.01" placeholder="e.g. £7.60">
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Total Website Visits</label>
              </div>
              <div class="column">
              </div>
              <div class="column">
                    <p>{{ websiteVisits }}</p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Website Conversion Rate</label>
              </div>
              <div class="column">
              </div>
              <div class="field-body column">
                <div class="field">
                  <div class="control">
                    <input class="input" v-model="conversionRate" type="number" step="0.01" placeholder="e.g. 2.4%">
                  </div>
                </div>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Conversions/Leads/Inquiries</label>
              </div>
              <div class="column">
              </div>
              <div class="column">
                <p> {{ conversions }} </p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Cost Per Raw Inquiry</label>
              </div>
              <div class="column">
              </div>
              <div class="column">
                <p> {{ costPerConversion }} </p>
              </div>
            </div>

        </div>
      </section>
    </body>

    <body>
      <section class="section">
        <div class="container">
          <h3 class="title is-size-4">Sales results</h3>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Quality leads (received a response)</label>
              </div>
              <div class="column">
                  <div class="control">
                    <input class="input" v-model="percentageResponse" type="number" min="0" max="3" step="0.1" placeholder="%">
                  </div>
              </div>
              <div class="column">
                <p> {{ qualityLeads }} </p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Proposal Given</label>
              </div>
              <div class="column">
                  <div class="control">
                    <input class="input" v-model="percentageProposals" type="text" placeholder="%">
                  </div>
              </div>
              <div class="column">
                <p> {{ proposals }} </p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">New Customer Acquired</label>
              </div>
              <div class="column">
                  <div class="control">
                    <input class="input" v-model="percentageAcquired" type="text" placeholder="%">
                  </div>
              </div>
              <div class="column">
                <p> {{ acquired }} </p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Average Deal Size</label>
              </div>
              <div class="column">
                  <div class="control">
                    <input class="input" v-model="dealSize" type="text" placeholder="£">
                  </div>
              </div>
              <div class="column">
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Product Margin</label>
              </div>
              <div class="column">
                  <div class="control">
                    <input class="input" v-model="margin" type="text" placeholder="%">
                  </div>
              </div>
              <div class="column">
              </div>
            </div>

        </div>






      </section>
    </body>

    <body>
      <section class="section">
        <div class="container">
          <h1 class="title is-size-4">Return on investment</h1>

                      <div class="field columns">
              <div class="field-label column">
                <label class="label">Net Revenue Per Lead</label>
              </div>
              <div class="column">
                <p> {{ netRevenue }} </p>
              </div>
              <div class="column">
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Average Cost Per Sale</label>
              </div>
              <div class="column">
              </div>
              <div class="column">
                <p> {{ costPerSale }} </p>
              </div>
            </div>

            <div class="field columns">
              <div class="field-label column">
                <label class="label">Return on Paid Search Investment</label>
              </div>
              <div class="column">
              </div>
              <div class="column">
                <p> {{ returnOnPaidInvestment}} </p>
              </div>
            </div>
        </div>
      </section>
    </body>

    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>Google Ads budget tool</strong> by <a href="https://www.joegoodson.com">Joseph Goodson</a>.
        </p>
      </div>
    </footer>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'PPC',
  data () {
    return {
      adSpend: '',
      costPerClick: '',
      conversionRate: '',
      percentageResponse: '',
      percentageProposals: '',
      percentageAcquired: '',
      dealSize: '',
      margin: ''
    }
  },
  computed: {
    annualSpend: function () {
      return (this.adSpend * 12)
    },
    websiteVisits: function (adSpend, costPerClick) {
      if (this.adSpend !== '') {
      return Math.round(this.adSpend / this.costPerClick)
      }
    },
    conversions: function () {
      return Math.round(((this.adSpend / this.costPerClick) * this.conversionRate) / 100)
    },
    costPerConversion: function () {
      return Math.round(this.adSpend / this.conversions)
    },
    qualityLeads: function () {
      return Math.round((this.conversions * this.percentageResponse) / 100 )
    },
    proposals: function () {
      return Math.round((this.qualityLeads * this.percentageProposals) / 100 )
    },
    acquired: function () {
      return Math.round((this.proposals * this.percentageAcquired) / 100 )
    },
    netRevenue: function () {
      return Math.round((this.dealSize * this.margin) / 100 )
    },
    costPerSale: function () {
      return Math.round(this.adSpend / this.acquired)
    },
    returnOnPaidInvestment: function () {
      return Math.round(((this.netRevenue - this.costPerSale ) / this.costPerSale) * 100)
    }
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  }


}
</script>
